<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <avs-button
        v-bind="{ ...attrs, ...$attrs }"
        v-on="{ ...on, ...$listeners }"
        fab
        icon
        iconI="mdi-content-duplicate"
        small
        label
        color="secondary"
        :disabled="disabled"
      />
    </template>
    <span>{{ spantext }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "DuplicateButton",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    spantext: {
      type: String
    }
  }
}
</script>
